import { getSessionValue, setSessionValue } from './session-storage-helper';

const encodeBase64 = (value) => {
  if (value === undefined || value === null) {
    return value;
  }

  if (typeof window === 'undefined' || typeof window.btoa !== 'function') {
    return value;
  }

  try {
    return window.btoa(value);
  }
  catch (err) {
    return value;
  }
};

const decodeBase64 = (value) => {
  if (value === undefined || value === null) {
    return value;
  }

  if (typeof window === 'undefined' || typeof window.atob !== 'function') {
    return value;
  }

  try {
    return window.atob(value);
  }
  catch (err) {
    return value;
  }
};

export const setPayerIdFromAccount = (accounts) => {
  const primaryAccount = accounts && accounts.length > 0 ? accounts[0] : undefined;
  if (primaryAccount) {
    const payerId = primaryAccount.ppPayerId || primaryAccount.ppShadowPayerId;
    const encodedPayerId = encodeBase64(payerId);
    setSessionValue('pId', encodedPayerId);
  }
  return accounts;
};

export const getPayerId = () => {
  const encodedPayerId = getSessionValue('pId');
  return decodeBase64(encodedPayerId);
};
